import styled from "styled-components";

const TransactionsStyleWrapper = styled.section`
  padding-bottom: 110px;
  background-color: #0d102d;

  .transaction_title {
    font-size: 40px;
    color: #ffffff;
    line-height: 50px;
    margin-bottom: 33px;
    text-transform: uppercase;
  }

  .transaction_tag{
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    text-transform: uppercase;
    color : #FF06B7;
    font-weight: 700;
  }

  .transaction_right_content {
    padding-right: 20px;
    padding-left: 20px;

    p {
      margin-bottom: 45px;
    }
  }


  @media only screen and (max-width: 1199px) {
    .transaction_right_content {
       
      p {
        font-size: 14px;
        line-height: 26px;
      }
    }
    .about_title {
      font-size: 38px;
      line-height: 53px;
      margin-bottom: 17px;
    }

  }

  @media only screen and (max-width: 991px) {
    .transaction_right_content {
      margin-top: 30px;
      p {
        font-size: 14px;
        line-height: 22px;
        margin-bottom: 10px;
      }
    }
    .about_title {
      font-size: 34px;
      line-height: 40px;
      margin-bottom: 17px;
    }

    .contact_btn{
      margin-top: 30px;
    }
  }

  @media only screen and (max-width: 767px) {
    padding: 0 0 80px 0;

    .transaction_tag{
      margin-top: 20px;
    }

    .transaction_title{
      font-size: 30px;
      line-height: 40px;
    }
    
    .contact_btn{
      margin-top: 30px;
    }
  }
`;

export default TransactionsStyleWrapper;
